
import { getToken } from "@/utils/auth";
import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false });

import pinia from '@/store'
import { usePermissionStore } from '@/store/modules/permission'
const usePermission = usePermissionStore(pinia);
function hasPermission (path) {
  return usePermission.getterPermMenuListInfo.includes(path)
}
  
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (!getToken() || to.path === '/login') {
    next()
    NProgress.done()
  } else {
    if (!usePermission.getterPermMenuListInfo.length) {
      usePermission.setPermissionInfo().then((res) => {
        if (hasPermission(to.path)) {
          next({ ...to, replace: true })
        } else {
          next()
        }
      })
    } else {
        next()
    }
  }
  
})

router.afterEach(() => {
  NProgress.done()
})
  